import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/saude/documentos/listar/form_edit'
import Head from '../../../../../components/head'


function EditarDocumentoSaudeScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Documento da Secretaria Municipal de Saúde" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDocumentoSaudeScreen;